<template>
  <div :class="'main-con ' + size">
    <gheader ref="gheader"></gheader>
  </div>
</template>
<script>
import gheader from "./main/header";
import global from "../utils/Global";

export default {
  data() {
    return {
      isLogin: false,
      size: "", //size-small
    };
  },
  mounted() {
    var that = this;
    that.onresizeHander();
    window.onresize = function () {
      that.onresizeHander();
    };
  },
  methods: {
    onresizeHander() {
      //   var w = $(window).width();
      //   if (w > 1700) {
      //     this.size = "size-big";
      //   } else if (w > 1480) {
      //     this.size = "size-normal";
      //   } else {
      //     this.size = "size-small";
      //   }
      if (this.$refs.gheader) {
        this.$refs.gheader.resize();
      }
    },
  },
  components: {
    gheader,
  },
};
</script>

<style>
.main-con {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/main.vue